<template>
  <el-card  v-loading="loading" :element-loading-text="loadingText">
    <!-- 查询条件表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="姓名:">
        <el-input v-model="searchFactor.fullName"  style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="用户名:">
        <el-input v-model="searchFactor.usrName" style="width:150px"></el-input>
      </el-form-item>
    <el-form-item label="团队:" >
      <el-select v-model="searchFactor.deptId" placeholder="请选择" >
        <el-option
          v-for="item in deptOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="完成状态:" >
        <el-select style="width:100px" v-model="searchFactor.state" >
          <el-option label="全部" value=""></el-option>
          <el-option label="未完成" value="0"></el-option>
          <el-option label="已完成" value="1"></el-option>
        </el-select>
      </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSearch">查询</el-button>

      <el-button type="warning"  @click="enterStateDownLoad">导出学习进度</el-button>
    </el-form-item>
    </el-form>
    <!-- 用户表格 -->
    <el-table
      :data="tableData"
      ref ="multipleTable"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%"
      class="tableClass">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="fullName"
        label="姓名"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="用户名"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="mobilePhone"
        label="手机"
        min-width="100">
      </el-table-column>
      <el-table-column
      prop="email"
        label="邮件"
        min-width="180">
      </el-table-column>
      <el-table-column
        prop="deptName"
        min-width="200"
        label="团队">
      </el-table-column>
      <el-table-column
        prop="gentle"
        min-width="50"
        label="性别" :formatter="formatGentle">
      </el-table-column>
      <el-table-column
        prop="active"
        min-width="70"
        label="状态" >
        <template slot-scope="scope">
          <span v-if = "scope.row.active == 1" style="color: greenyellow">  激活</span>
          <span v-else  style="color: red" > 禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gentle"
        min-width="100"
        label="学习进度" :formatter="formatStudyState">
      </el-table-column>
      <el-table-column
        prop="createTime"
        min-width="80"
        label="开始学习时间">
      </el-table-column>
      <el-table-column
        prop="createTime"
        min-width="80"
        label="结束学习时间">
        <template slot-scope="scope">
          <span v-if = "scope.row.studyState == 5" > {{ scope.row.updateTime }}</span>
          <span v-else  style="color: red" > </span>
        </template>
      </el-table-column>
      <el-table-column label="操作"  min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            操作
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"showDetail", index:scope.$index,data:scope.row}'><i class="el-icon-view" style="color:rgb(45, 246, 18)" ></i> <span>查看详情</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页插件 -->
    <el-pagination
      background
      height="200px"
      layout="total,prev, pager, next"
      :current-page.sync="pager.currentPage"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin:10px">
    </el-pagination>
    <el-dialog :close-on-click-modal="false" width="30%" :visible.sync="dialogVisual.studyStateVisual" v-on:close ="clearStudyStateFrom" >
      <div slot="title" class="dialog-footer">
        <span> 用户准入教程学习进度 </span>
      </div>
      <div style="margin: auto; padding: auto; text-align: left">
        <span style="font-size:18px;  font-weight:700">实验室准入教程</span>
          <i v-if = "enterState.studyState >= 5" style="color: #67C23A;" class="el-icon-success"></i>
        </div>
        <div style="line-height: 50px;text-align: left;">
          <div style="margin-left:10px;cursor: pointer;" >
            <i  v-if = "enterState.studyState >= 1" style="color: #67C23A;" class="el-icon-success"></i>
            <i  v-else class="el-icon-success"></i>
            <span v-if = "knBasicList.length == 0">实验室准入规章制度</span>
            <el-dropdown v-else  >
              <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;" >
                实验室准入规章制度<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  divided v-for=" item in regBasicList"  :key="item.id">
                  <i v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                  <i v-else class="el-icon-success"></i>
                  {{ item.theme }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> 
          <div style="margin-left:10px;cursor: pointer;" >
            <i v-if = "enterState.studyState >= 2" style="color: #67C23A;" class="el-icon-success"></i>
            <i v-else class="el-icon-success"></i>
            <span v-if = "knBasicList.length == 0" >实验室准入安全知识</span>
            <el-dropdown v-else  >
              <span class="el-dropdown-link" style="font-size:17px;cursor: pointer; ">
                实验室准入安全知识<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided v-for=" item in knBasicList" :key="item.id">
                  <i  v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                  <i v-else class="el-icon-success"></i>
                  {{item.theme}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="margin-left:10px;cursor: pointer;">
            <i v-if = "enterState.studyState >= 3" style="color: #67C23A;" class="el-icon-success"></i>
            <i v-else class="el-icon-success"></i>
            <span>实验室准入知识题库</span>
          </div> 
          <div style="margin-left:10px;cursor: pointer;">
            <i  v-if = "enterState.studyState >= 4" style="color: #67C23A;" class="el-icon-success"></i>
            <i v-else class="el-icon-success"></i>
            <span v-if = "examThemeBasic.id == 0 " >实验室准入安全考试</span>
            <el-dropdown v-else>
              <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;">
                实验室准入安全考试<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if = "examThemeBasic.examCount == 1"  divided>
                  <i :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 第1次考试 </i>
                </el-dropdown-item>
                <el-dropdown-item v-else  divided v-for=" (item,index) in examThemeBasic.examCount" :command="item" :key="index">
                  <i v-if = " item == 1"  class="el-icon-warning"> 第1次考试 </i>
                  <i v-else-if = "item < examThemeBasic.examCount && item > 1  "  class="el-icon-warning">{{ ' 第' + (item - 1) + '次重考'}} </i>
                  <i v-else :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 第{{item - 1}}次重考</i>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> 
          <div style="margin-left:10px;cursor: pointer;">
            <i  v-if = "enterState.studyState >= 5" style="color: #67C23A;" class="el-icon-success"></i>
            <i  v-else class="el-icon-success"></i>
            <span>实验室准入安全责任书</span>
          </div> 
        </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import {utf8ByteArrayStrToStr,getToken} from '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'

export default {
  name : 'pc_ctr_enter',
  data() {
    return {
      deptOptions: [],
      searchFactor: {
        fullName: '',
        usrName: '',
        actState: '',
        roleName:'',
        deptId :''
      },
      dialogVisual:{
        studyStateVisual:false
      },
      enterState :{
        studyState : 0
      },
      regBasicList  : [],
      knBasicList : [],
      qmBasic :{
        id :  0,
      },
      examThemeBasic :{
        id :0,
        examCount : 1,
        result : null
      },
      safeBookBasic :{
        id : 0
      },
      tableData: [],
      pager:{
        currentPage: 0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      userInfoFile:{
        headers: {token:""}
      },
      loading: false,
      loadingText:''
    }
  },
  
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'showDetail' :
          this.showDetail(index,row)
          break
      }
    },
    // 生成表格编号
    indexMethod(index){
      return index+1
    },
    // 格式化性别字段
    formatGentle(row, index){
      if(row.gentle == 1){
        return '男'
      }else{
        return '女'
      }
    },
    formatStudyState(row,index){
      if(row.studyState == null){
        return "0.00%"
      }
      if(row.studyState == 1){
        return "20.00%"
      }
      if(row.studyState == 2){
        return "40.00%"
      }
      if(row.studyState == 3){
        return "60.00%"
      }
      if(row.studyState == 4){
        return "80.00%"
      }
      if(row.studyState == 5){
        return "100.00%"
      }
    },
    showDetail(index,row){
      this.dialogVisual.studyStateVisual = true
      this.enterStateLoad(row.userId)
    },
    handleCurrentChange(pageNo){
      this.userEnterListLoad(pageNo)
    },
    // 加载用户列表
    userEnterListLoad (pageNo){
      let url = "/bc/exa/enter/enterPage"
      let { 
        fullName,
        usrName,
        state,
        deptId 
      } =  this.searchFactor 
      
      let dat0 = {
        pageSize: PAGE_SIZE,
        fullName,
        usrName,
        state,
        deptId,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableData = [];
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount
              this.pager.currentPage = pageNo
            } else {
              this.$message({
              showClose: true,
              message: '未查询到用户学习信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) =>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },



    // 下载模版
    enterStateDownLoad(){
      this.loading = true
      this.loadingText = '导出中...'
   
      let { 
        fullName,
        usrName,
        state,
        deptId 
      } =  this.searchFactor 
      
      let outData = {
        pageSize: PAGE_SIZE,
        fullName,
        usrName,
        state,
        deptId,
        pageNo:1
      }
      let that = this
      let url = "/bc/exa/enter/downloadEnterPage"; //接口
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.responseType = "blob";  // 返回类型blob
      xhr.setRequestHeader("Content-type", "application/json;charset=utf-8");
      xhr.setRequestHeader("token", this.userInfoFile.headers.token); //这个看后端接口情况决定要不要写
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
        that.loading = false;
        // 请求完成
        if (this.readyState == 4 && this.status === 200) {
          // 返回200
          let code = this.getResponseHeader("code");
          if(code != '0'){
            let message = this.getResponseHeader("message")
            let messageUtf8 = utf8ByteArrayStrToStr(message)
            that.$message({
              showClose: true,
              message:  messageUtf8,
              type: 'error',
              duration: MESSAGE_DURATION
            })
            return
          }

          var blob = this.response;
          const url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          a.download = '准入课程学习明细.xls'
          a.href = url
          document.body.appendChild(a)
          a.click();
          document.body.removeChild(a)
        } else {
          that.$message({
          showClose: true,
          message: this.status + xhr.statusText,
          type: 'error',
          duration: MESSAGE_DURATION
          })
        }
      };
      xhr.onerror = function () {
        that.$message({
          showClose: true,
          message:  '下载失败' +  xhr.statusText,
          type: 'error',
          duration: MESSAGE_DURATION
        })
        that.loading = false;
      }
        // 发送ajax请求
      xhr.send(JSON.stringify(outData))
    },

    enterStateLoad(userId){
      let url = "/bc/exa/enter/stateShow/" + userId
      let dat0 = {
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.clearStudyStateFrom()
          let dat = response.data.data;
          if(dat.studyState != null ){
            this.enterState.studyState = dat.studyState
          }

          if( dat.bcRegLearnSearchVoList != null && dat.bcRegLearnSearchVoList.length > 0 ){
            dat.bcRegLearnSearchVoList.forEach(t=>{
            this.regBasicList.push(t)
           })
          }

          if( dat.bcKnLearnSearchVoList != null && dat.bcKnLearnSearchVoList.length > 0 ){
            dat.bcKnLearnSearchVoList.forEach(t=>{
              this.knBasicList.push(t)
            })
          }
           
          if(dat.bcQuestionModuleBasicVo != null ) {
            this.qmBasic.id = dat.bcQuestionModuleBasicVo.id
          }

          if(dat.bcExamThemeBasicVo != null ) {
            this.examThemeBasic.id = dat.bcExamThemeBasicVo.id
            if(dat.bcExamUserEntity != null){
      
              this.examThemeBasic.examCount =  dat.bcExamUserEntity.examCount
              if(dat.bcExamUserEntity.result != null){
                this.examThemeBasic.result = dat.bcExamUserEntity.result == 1
              }
            }
          }

          if(dat.bcQuestionModuleBasicVo != null ) {
            this.safeBookBasic.id = dat.bcSafeBookBasicVo.id
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    clearStudyStateFrom(){
      this.enterState.studyState= 0
      this.regBasicList= []
      this.knBasicList= []
      this.qmBasic.id = 0
      
      this.examThemeBasic.id  = 0
      this.examThemeBasic.examCount  = 1
      this.examThemeBasic.result  = null
      this.safeBookBasic.id = 0

    },
    // 加载团队清单
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            this.deptOptions.splice(0)
            this.deptOptions.push({value: "",label: '全部' })
            response.data.data.forEach(t=>{
              this.deptOptions.push({value: t.id,label: t.deptName })
            })
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    // 查询用户列表
    onSearch(){
      this.userEnterListLoad(1)
    }
  },
  created () {
    setTimeout(()=>{getToken(this.userInfoFile.headers)},200)
    this.deptListLoad();
    this.userEnterListLoad(1);
  }
}
</script>
  
<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_enter.vue